function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Honeybadger } from "@honeybadger-io/react";
import { ErrorNotifier, errorDataBuilder, sourceTag } from "../../api/src/utils/error-notifier";
import { REVERSE_PROXY_NAMESPACE } from "./constants";
import { isShopperResolvable } from "./shopper-error";

// Our own API handlers already notify Honeybadger, carrying the request id,
// path and body the browser never sees. When their response came back as an
// axios failure we filed a second, thinner fault for the same event - a
// create-order 422 produced a group of 64 on each side, and the FE copy's whole
// backtrace was the React root. Report only what the API never saw: dropped
// connections, timeouts, CORS, and calls to anyone other than us.
var reportedByOurApi = function reportedByOurApi(error) {
  var _ref = error !== null && error !== void 0 ? error : {},
    config = _ref.config,
    response = _ref.response;
  if (!response || !(config !== null && config !== void 0 && config.url)) return false;

  // The namespace is built from STOREFRONT_HOST. Unset, it matches every URL
  // (startsWith("")) or none ("undefined/..."), and the first would mute the
  // whole frontend. Skip deduping rather than risk silence.
  if (!REVERSE_PROXY_NAMESPACE || REVERSE_PROXY_NAMESPACE.startsWith("undefined")) return false;
  return config.url.startsWith(REVERSE_PROXY_NAMESPACE);
};

// Axios reports a request that never got an answer - timed out, dropped, DNS
// gone - with a `code` and no `response`. Call sites read the status as
// `error.response?.status ?? 500`, so all of those arrived as `[FE][500]` and
// read as server faults of ours. 0 is what this codebase already uses to mean
// "no HTTP response" (see the existing `[FE][0] TimeoutError` group).
var NO_RESPONSE = 0;
var NO_RESPONSE_CODES = ["ECONNABORTED", "ETIMEDOUT", "ERR_NETWORK"];
var effectiveStatus = function effectiveStatus(error, statusCode) {
  var _ref2 = error !== null && error !== void 0 ? error : {},
    response = _ref2.response,
    code = _ref2.code;
  if (response) return statusCode;
  return code && NO_RESPONSE_CODES.includes(code) ? NO_RESPONSE : statusCode;
};

// `source` names the call site, so a fault says where it came from without
// depending on the backtrace resolving.
//
// Kept out of `name` and `message` deliberately: those two form the fingerprint,
// and folding the source in would re-group every existing fault and read as a
// flood of new errors.
export var reportFrontendError = function reportFrontendError(error, statusCode, source, extra) {
  if (isShopperResolvable(error)) return;
  if (reportedByOurApi(error)) return;
  var data = errorDataBuilder("FE", effectiveStatus(error, statusCode), error);
  ErrorNotifier.notify(error, _objectSpread(_objectSpread({}, data), {}, {
    tags: "".concat(data.tags, ", ").concat(sourceTag(source)),
    context: _objectSpread(_objectSpread({}, data.context), {}, {
      source: source
    }, extra)
  }));
};

// Uncaught exceptions and unhandled rejections are picked up by Honeybadger's
// own global handlers, so they never reach reportFrontendError and the rule
// above never saw them - a decline thrown inside a payment SDK callback has
// nothing of ours on the stack to catch it. Apply the same rule there.
// Only name and message survive onto a Notice, which is all the message-based
// checks need; the status ones simply never match.
// Guarded because this runs at the entry point before React mounts: a throw
// here would take the whole checkout down to spare Honeybadger some noise.
export var registerShopperErrorFilter = function registerShopperErrorFilter() {
  try {
    Honeybadger.beforeNotify(function (notice) {
      return !isShopperResolvable(notice);
    });
  } catch (error) {}
};